import React, { useState, useEffect, useRef } from "react";

import Vedioadvertisments from '../PromotionsandDiscounts/Food/Vedioadvertisments';
import CatringsCoupons from "./CatringsCoupons";
import Cateringtopresturent from "../PromotionsandDiscounts/Caterings/Cateringtopresturent";
import { useNavigate } from 'react-router-dom';
import './Cateringsreport.css'
import { Link } from 'react-router-dom';
import Cateringascrolling from "./Cateringascrolling";
function Cateringspromotionspage() {
    const [activeTab, setActiveTab] = useState("first"); // default tab
    const isMobile = window.innerWidth <= 768;

    const [isPaused, setIsPaused] = useState(false);

    const toggleCard = (index) => {
        setExpandedCard(expandedCard === index ? null : index);
    };
    const [expandedCard, setExpandedCard] = useState(null); // ✅ expand state
    const scrollRef = useRef(null);
    useEffect(() => {
        const scrollContainer = scrollRef.current;
        let scrollInterval;

        if (scrollContainer && !isPaused) {
            scrollInterval = setInterval(() => {
                if (
                    scrollContainer.scrollTop + scrollContainer.clientHeight >=
                    scrollContainer.scrollHeight
                ) {
                    scrollContainer.scrollTop = 0;
                } else {
                    scrollContainer.scrollTop += 1; // scroll speed
                }
            }, 50);
        }

        return () => clearInterval(scrollInterval);
    }, [isPaused]); // pause state control karega



    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"> </div>
                <div className="col-lg-7">  <div
                    style={{
                        width: "100%",
                        maxWidth: "100vw",
                        // margin: '150px 230px',
                        // marginTop: "150px",
                        fontFamily: "Arial, sans-serif",
                    }}
                    className="catering-promotions"
                >
                    <p
                        className="breadcrumb maamaas-home-bredcum"
                        style={{
                            position: "fixed",
                            top: window.innerWidth <= 425 ? "50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "55px" : "64px",
                            left: "2vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            zIndex: 1000,
                            padding: "15px 0",
                            fontSize: isMobile ? "16px" : "18px",
                            fontWeight: isMobile ? "normal" : "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >

                        <Link
                            to="/cateringdashboard"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Catering & Services

                        </Link>

                        <span className="separator"> &gt; </span>
                        <Link

                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Promotions Discounts
                        </Link>
                    </p>
                    {/* Tabs Header */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: window.innerWidth <= 768 ? "column" : "row", // 👈 stack vertically on mobile
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "10px",
                            marginBottom: "20px",
                            marginTop: "-20px",
                        }}
                    >
                        <button
                            onClick={() => setActiveTab("first")}
                            style={{
                                padding: "10px 20px",
                                cursor: "pointer",
                                border: "1px solid rgb(177 93 198)",
                                borderRadius: "8px",
                                fontWeight: "bold",
                                backgroundColor: activeTab === "first" ? "rgb(177 93 198)" : "white",
                                color: activeTab === "first" ? "white" : "rgb(177 93 198)",
                                transition: "0.3s",
                                width: window.innerWidth <= 768 ? "200px" : "auto",
                            }}
                        >
                            Coupons Offers
                        </button>

                        <button
                            onClick={() => setActiveTab("second")}
                            style={{
                                padding: "10px 20px",
                                cursor: "pointer",
                                border: "1px solid rgb(177 93 198)",
                                borderRadius: "8px",
                                fontWeight: "bold",
                                backgroundColor: activeTab === "second" ? "rgb(177 93 198)" : "white",
                                color: activeTab === "second" ? "white" : "rgb(177 93 198)",
                                transition: "0.3s",
                                width: window.innerWidth <= 768 ? "200px" : "auto",
                            }}
                        >
                            Adevertisements
                        </button>
                        <button
                            onClick={() => setActiveTab("third")}
                            style={{
                                padding: "10px 20px",
                                cursor: "pointer",
                                border: "1px solid rgb(177 93 198)",
                                borderRadius: "8px",
                                fontWeight: "bold",
                                backgroundColor: activeTab === "third" ? "rgb(177 93 198)" : "white",
                                color: activeTab === "third" ? "white" : "rgb(177 93 198)",
                                transition: "0.3s",
                                width: window.innerWidth <= 768 ? "200px" : "auto",
                            }}
                        >
                            Top Resturent
                        </button>
                    </div>
                    <div
                    >
                        {activeTab === "first" && <CatringsCoupons />}
                        {activeTab === "second" && <Vedioadvertisments />}
                        {activeTab === "third" && <Cateringtopresturent />}
                    </div>
                    <div>
                        <Cateringascrolling />
                        {/* <Cateringscrollingorder /> */}
                    </div>
                </div>
                </div>
                <div className="col-lg-3"> </div>
            </div>
        </div>





    );
}

export default Cateringspromotionspage;
